module.exports = __webpack_public_path__ + "static/media/linkedin.89dcd695.svg";